import React, { Component } from 'react';
import { Table, Input, Row, Col, Button, Modal } from 'antd'
import { EditOutlined, DeleteOutlined, PlusOutlined, RedoOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import RouteFormModal from './RouteFormModal';
import { getRoutes, deleteRoute, restoreRoute } from '../../services/route';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { set_route_id } from '../../redux/actions/route';
import { clear_customer_id } from '../../redux/actions/customer';


const { Search } = Input;
const confirm = Modal.confirm;

class RouteList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 1,
            pageSize: 50,
            total: 10,
            sortBy: "created_at",
            sortDir: "ascend",
            q: "",
            dataLoading: false,
            formModalVislble: false,
            modalEditing: false,
            selectedData: {}
        }

        this.getData = this.getData.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onPageSizeChange = this.onPageSizeChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onRowEditClick = this.onRowEditClick.bind(this);
        this.onRowDeleteClick = this.onRowDeleteClick.bind(this);
        this.setFormModalVisible = this.setFormModalVisible.bind(this);
        this.reloadAfterCreate = this.reloadAfterCreate.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowRestoreClick = this.onRowRestoreClick.bind(this);
        this.onNameClicked = this.onNameClicked.bind(this)
        this.getTruckTypeName = this.getTruckTypeName.bind(this)
    }

    onPageChange(page, pageSize) {
        this.setState({
            page: page,
            pageSize: pageSize
        }, () => {
            this.getData()
        })
    }

    onPageSizeChange(current, size) {
        this.setState({
            page: current,
            pageSize: size
        }, () => {
            this.getData()
        })
    }

    onTableChange(pagination, filters, sorter) {
        const { page, pageSize, sortBy, sortDir } = this.state
        this.setState({
            page: pagination['current'] || page,
            pageSize: pagination['pageSize'] || pageSize,
            sortBy: sorter['columnKey'] || sortBy,
            sortDir: sorter['order'] || sortDir,
        }, () => {
            this.getData()
        })
    };

    onSearch(value) {
        this.setState({
            q: value,
            page: 1
        }, () => {
            this.getData()
        })
    }

    async getData() {
        this.setState({
            dataLoading: true
        }, async () => {
            const { q, page, pageSize, sortBy, sortDir } = this.state
            let result = await getRoutes(q, { "route.is_active": true }, page, pageSize, sortBy, sortDir)
            const routes = result.data.routes
            this.setState({
                data: routes,
                total: result.data.total,
                dataLoading: false
            })
        })
    }

    async reloadAfterCreate() {
        // const { pageSize, page, total } = this.state
        // let totalPages = Math.ceil(total/pageSize)
        // if (total === pageSize && page === totalPages){
        //     totalPages += 1
        // }

        this.setState({
            page: 1
        }, () => {
            this.getData()
        })
    }

    onRowEditClick(row) {
        // row['check_in_at'] = moment(row['check_in_at'])
        const prepareForm = this.formModal.prepareForm
        this.setState({
                formModalVislble: true,
                selectedData: row,
                modalEditing: true
        }, () => {
            setTimeout(function () { prepareForm(); }, 100);
        });
    }

    onRowDeleteClick(row, onPageChange, page, pageSize) {
        confirm({
            title: `ต้องการลบ ${row.name} หรือไม่?`,
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            async onOk() {
                let response = await deleteRoute(row.id);
                if (response.status === 200) {
                    await onPageChange(page, pageSize);
                }
            },
            onCancel() { }

        });
    }

    onRowRestoreClick(row, onPageChange, page, pageSize) {
        confirm({
            title: `ต้องการกู้คืน ${row.name} หรือไม่?`,
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            async onOk() {
                let response = await restoreRoute(row.id);
                if (response.status === 200) {
                    await onPageChange(page, pageSize);
                }
            },
            onCancel() { }

        });
    }

    async onNameClicked(row) {
        const { history } = this.props;
        history.push(`/routes/${row.id}`)
    }

    getTruckTypeName(row) {
        if (row.truck_type === "FOUR_WHEEL"){
            return "4 ล้อ"
        }
        else if (row.truck_type === "SIX_WHEEL"){
            return "6 ล้อ"
        }
        return "-"
    }

    setFormModalVisible(val) {
        this.setState({
            formModalVislble: val,
            selectedData: {}
        })
    }

    componentWillMount() {
        this.getData()
    }

    render() {

        const { data, total, page, pageSize, dataLoading, formModalVislble, selectedData, modalEditing } = this.state

        let tableColumns = [
            {

                title: 'ชื่อสาย',
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                render: (text, row) => (
                    <a onClick={() => this.onNameClicked(row)}>{row.name}</a>
                )
            },
            {
                title: 'รายละเอียด',
                dataIndex: 'description',
                key: 'description',
                sorter: true
            },
            {

                title: 'ประเภทรถ',
                dataIndex: 'truck_type',
                key: 'truck_type',
                sorter: true,
                render: (text, row) => (
                    <span>{this.getTruckTypeName(row)}</span>
                )
            },
            {
                title: 'ทะเบียนรถ',
                dataIndex: 'truck_license',
                key: 'truck_license',
                sorter: false
            },
            {
                title: 'จำนวนร้านค้า',
                dataIndex: 'customer_count',
                key: 'customer_count',
                sorter: false
            },
            {
                title: 'เปิดใช้งาน',
                dataIndex: 'is_active',
                key: 'is_active',
                sorter: true,
                render: (text, row) => (
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        {text ? <CheckCircleOutlined style={{ color: '#52C41A' }} /> : <CloseCircleOutlined style={{ color: '#FF4D4F' }} />}
                    </div>
                )
            },
            {
                title: 'ตัวเลือก',
                dataIndex: 'action',
                key: 'action',
                render: (text, row) => (
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            color="default"
                            shape="circle"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => this.onRowEditClick(row)}
                            style={{ marginRight: 5 }}
                        />
                        <Button
                            color={row.is_active ? 'danger' : 'primary'}
                            variant="solid"
                            shape="circle"
                            size="small"
                            icon={row.is_active ? <DeleteOutlined /> : <RedoOutlined />}
                            onClick={
                                row.is_active ?
                                () => this.onRowDeleteClick(row, this.getData, page, pageSize)
                                : () => this.onRowRestoreClick(row, this.getData, page, pageSize)
                            }
                        />
                    </div>
                )
            }

        ]

        return (
            <div>
                <Row>
                    <Col span={8} xs={6} sm={6} md={8} lg={8} xl={8} xxl={8}/>
                    <Col span={10} xs={12} sm={12} md={10} lg={10} xl={10} xxl={10}>
                        <Search
                            placeholder="ค้นหาด้วยชื่อ"
                            onSearch={this.onSearch}
                        />
                    </Col>
                    <Col span={1} offset={5}>
                        <Button
                            style={{ float: 'right' }}
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => this.setState({ formModalVislble: true, modalEditing: false })}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={24}>
                        <Table
                            rowKey={'id'}
                            columns={tableColumns}
                            dataSource={data}
                            bordered
                            locale={{ filterConfirm: 'OK', filterReset: 'รีเซ็ต', emptyText: 'ไม่มีข้อมูล' }}
                            pagination={{ current: page, pageSize: pageSize, total: total, showSizeChanger: true, pageSizeOptions: ['5', '10', '20', '50'] }}
                            loading={dataLoading}
                            onChange={this.onTableChange}
                        />
                    </Col>
                </Row>

                <RouteFormModal
                    visible={formModalVislble}
                    setVisible={this.setFormModalVisible}
                    reloadData={this.getData}
                    reloadAfterCreate={this.reloadAfterCreate}
                    editing={modalEditing}
                    data={selectedData}
                    onRef={ref => (this.formModal = ref)}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default withRouter(connect(mapStateToProps)(RouteList));